import { IconChevronDown } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon } from '@rossum/ui/material';

type ActivityDetailToggleProps = {
  isExpanded: boolean;
};

export const ActivityDetailToggle = ({
  isExpanded,
}: ActivityDetailToggleProps) => (
  <IconButton
    size="small"
    tabIndex={-1}
    aria-label={isExpanded ? 'Close' : 'Open'}
  >
    <SvgIcon
      sx={t => ({
        transform: `scaleY(${isExpanded ? -1 : 1})`,
        transition: t.transitions.create('transform', {
          duration: t.transitions.duration.shortest,
        }),
      })}
      fontSize="inherit"
    >
      <IconChevronDown />
    </SvgIcon>
  </IconButton>
);
